<template>
  <div ref="root" id="header" class="header">
    <h1>
      <router-link to="/"><img :class="shouldShowHelpPopup ? 'active' : ''" class="top-inner-img"
          src="~@/assets/img/logo/logo_simple.png" />
        CYCLONE GYM
      </router-link>
    </h1>
    <ul class="header__list">
      <li class="header__item sp-none">
        <router-link :to="$route.path === '/' ? '#concept' : '/#concept'"> コンセプト </router-link>
      </li>
      <li class="header__item sp-none">
        <router-link :to="$route.path === '/' ? '#news' : '/#news'"> お知らせ </router-link>
      </li>
      <li class="header__item sp-none">
        <router-link :to="$route.path === '/' ? '#lesson' : '/#lesson'"> スケジュール </router-link>
      </li>
      <li class="header__item sp-none">
        <router-link :to="$route.path === '/' ? '#menu' : '/#menu'"> クラス紹介 </router-link>
      </li>
      <li class="header__item sp-none">
        <router-link :to="$route.path === '/' ? '#price' : '/#price'"> 料金 </router-link>
      </li>
      <li class="header__item sp-none">
        <router-link :to="$route.path === '/' ? '#flow' : '/#flow'"> 入会の流れ </router-link>
      </li>
      <li class="header__item sp-none">
        <router-link :to="$route.path === '/' ? '#qa' : '/#qa'"> よくある質問 </router-link>
      </li>
      <li class="header__item sp-none">
        <router-link :to="$route.path === '/' ? '#staff' : '/#staff'"> スタッフ紹介</router-link>
      </li>
      <li class="header__item sp-none">
        <router-link to="/Facilittes"> 施設紹介</router-link>
      </li>
      <li class="header__item sp-none">
        <router-link :to="$route.path === '/' ? '#info' : '/#info'"> ジム案内</router-link>
      </li>
      <li class="header__item sp-none">
        <router-link :to="$route.path === '/' ? '#access' : '/#access'"> アクセス</router-link>
      </li>
      <li class="header__item sp-none">
        <router-link to="/Contact"> お問い合わせ </router-link>
      </li>
    </ul>
    <button :class="shouldShowHelpPopup ? 'active' : ''" v-on:click="onTapReturnButton" class="menu-trigger pc-none">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, onUpdated, computed, ComputedRef } from 'vue'
import { useApplicationStore } from '@/store/modules/applicationModule'
import { useRoute } from 'vue-router'

interface State {
  active: any
}

export default defineComponent({
  components: {},
  setup() {
    const ApplicationStore = useApplicationStore()
    const root = ref(null)
    const child = ref(null)
    const state = reactive<State>({
      active: false,
    })

    const shouldShowHelpPopup = computed(() => ApplicationStore.getShouldShowHelpPopup)

    const myFunc = function (shouldShowHelpPopup) {
      const position = Math.floor(window.innerHeight * 0.75)
      const x = window.scrollY
      // console.log(x)

      const target = document.getElementById('header')
      if (position < x) {
        target.classList.add('active')
      } else if (shouldShowHelpPopup === true) {
        target.classList.add('active')
      } else {
        target.classList.remove('active')
      }
    }

    window.addEventListener('scroll', async function () {
      myFunc(shouldShowHelpPopup.value), false
    })

    const onTapReturnButton = () => {
      state.active = !state.active
      console.log(shouldShowHelpPopup.value)
      console.log(state.active)

      if (state.active === true) {
        ApplicationStore.UPD_HELP_POPUP(true)
      } else {
        ApplicationStore.UPD_HELP_POPUP(false)
      }
    }

    return {
      root,
      child,
      state,
      onTapReturnButton,
      shouldShowHelpPopup,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '~@/assets/css/colors';

.header {
  display: flex;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.05) 89%, rgba(0, 0, 0, 0));
  font-weight: 600;
  position: fixed;
  z-index: 9999;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;

  & h1 {
    & a {
      display: flex;
      align-items: center;
      font-size: 2rem;
      font-family: 'Noto Serif JP', serif;
      font-weight: 600;
      color: #fff;
    }
  }

  & img {
    max-width: 50px;
    margin-right: 10px;
  }

  &__ {
    &list {
      display: flex;

      & a {
         font-size: 1.4rem;
        color: #fff;
        font-family: 'Noto Serif JP', serif;
      }
    }

    &item {
      padding: 10px;

      &:last-child {
        background-color: $sub;
      }
    }

    &return-button {
      padding: 12px 9px;
      position: absolute;
      top: 0;
      left: 84px;
      font-size: 1.25rem;
      color: $gray1;
      border-bottom: 3px solid transparent;
      line-height: 27px;

      &--active {
        margin-top: 6px;
        padding: 9px 9px;
        background: #fff;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 3px solid #fff;
        line-height: 21px;
      }
    }

    &hospital-area {
      position: relative;
      width: 772px;
      margin-left: 130px;

      &::before,
      &::after {
        content: '';
        position: absolute;
        top: 9px;
        width: 1px;
        height: 30px;
        background: #0000001a;
      }

      &::before {
        left: -1px;
      }
      &::after {
        right: -1px;
      }
    }
  }
}

.gradient-cover {
  position: absolute;
  top: 0;
  right: 0;
  width: 38px;
  height: 100%;
  background: linear-gradient(to right, #e6f4f43c 0%, #e6f4f4 100%);
}

.iscroll-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.iscroll__scroller {
  padding-right: 38px;
  width: min-content;
}

// override HelpButton
.help {
  position: absolute;
  top: 10px;
  right: 16px;
  width: 30px;
  height: 30px;
  background: $main;
  font-size: 10px;
  color: #fff;
}

// override Tabs
:deep(.tabs-area) {
  margin-top: 6px;
}



:deep(.tab__text) {
  font-size: 1.5rem;
  line-height: 1;
}

.menu-trigger,
.menu-trigger span {
  display: inline-block;
  transition: all 0.4s;
  box-sizing: border-box;
  position: relative;
  z-index: 100;
}

.menu-trigger {
  position: relative;
  width: 32px;
  height: 26px;
  background: none;
  border: none;
  appearance: none;
  cursor: pointer;
}

.menu-trigger span {
  position: absolute;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #fff;
  border-radius: 4px;
}

.menu-trigger span:nth-of-type(1) {
  top: 0;
}

.menu-trigger span:nth-of-type(2) {
  top: 11px;
}

.menu-trigger span:nth-of-type(3) {
  bottom: 0;
}

//クラスが付与されたら
.menu-trigger.active span:nth-of-type(1) {
  transform: translateY(11px) rotate(-45deg);
}

.menu-trigger.active span:nth-of-type(2) {
  opacity: 0;
}

.menu-trigger.active span:nth-of-type(3) {
  transform: translateY(-11px) rotate(45deg);
}

.fade-right-out {
  transform: translateY(0);
  opacity: 1;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateY(-100%);
    opacity: 0;
  }
}

.pc-none {
  display: none;
}

@media screen and (max-width: 1287px) {
  .pc-none {
    display: block;
  }

  .sp-none {
    display: none;
  }
}

a {
  text-decoration: none;
}
</style>
